// components/SearchActivityForm.js
import React, { useEffect } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import { MapContainer, TileLayer, Marker, Circle, useMapEvents } from 'react-leaflet';
import RecenterMapOnce from './RecenterMapOnce'

import 'react-datepicker/dist/react-datepicker.css';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

function LocationSelector({ setPosition }) {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    }
  });
  return null;
}

function SearchActivityForm({
  formData,
  setFormData,
  position,
  setPosition,
  handleSubmit,
  loading,
}) {
  useEffect(() => {
    if (!position) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setPosition({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude
          });
        },
        (err) => {
          console.warn('Geolocation error:', err);
        },
        { enableHighAccuracy: true }
      );
    }
  }, [position, setPosition]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'hourFrom') {
      setFormData((prev) => ({ ...prev, hourRange: [value, prev.hourRange[1]] }));
    } else if (name === 'hourTo') {
      setFormData((prev) => ({ ...prev, hourRange: [prev.hourRange[0], value] }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleDateRangeChange = (dates) => {
    const [start, end] = dates;
    setFormData({ ...formData, dateRange: [start, end] });
  };
  // console.log('position', position)

  return (
    <div>


      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Activity Type <span className="text-danger">*</span></label>
          <select
            className="form-select"
            name="activityType"
            value={formData.activityType}
            onChange={handleChange}
            required
          >
            <option value="bar or restaurant">Bar or Restaurant</option>
            <option value="park activity">Park activity</option>
            <option value="sport - badminton">Sport - Badminton</option>
            <option value="sport - golf">Sport - Golf</option>
            <option value="sport - pingpong">Sport - Table tennis</option>
            <option value="sport - petang">Sport - Pétanque</option>
            <option value="sport - tennis">Sport - Tennis</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Target Location <span className="text-danger">*</span></label>
          <MapContainer
            center={position || { lat: 40.70979, lng: -74.00425 }}
            zoom={11}
            style={{ height: '300px', width: '100%', zIndex: 0 }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <LocationSelector setPosition={setPosition} />
            <RecenterMapOnce position={position} />
            {position && (
              <>
                <Marker position={position} />
                <Circle center={position} radius={formData.radius * 1000} />
              </>
            )}
          </MapContainer>
        </div>

        <div className="mb-3">
          <label className="form-label">Radius (km) <span className="text-danger">*</span></label>
          <input
            type="number"
            className="form-control"
            name="radius"
            value={formData.radius}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">
            Date Range <span className="text-danger">*</span>
          </label>
          <div>
            <DatePicker
              selectsRange
              startDate={formData.dateRange[0]}
              endDate={formData.dateRange[1]}
              onChange={handleDateRangeChange}
              className="form-control"
              required
              calendarClassName="datepicker-popup"
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Hour Range <span className="text-danger">*</span></label>
          <div className="d-flex gap-2">
            <input
              type="time"
              className="form-control"
              name="hourFrom"
              value={formData.hourRange[0]}
              onChange={handleChange}
              required
            />
            <input
              type="time"
              className="form-control"
              name="hourTo"
              value={formData.hourRange[1]}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Number of People</label>
          <input
            type="number"
            className="form-control"
            name="numberOfPeople"
            value={formData.numberOfPeople}
            onChange={handleChange}
            disabled
          />
        </div>

        <button type="submit" className="btn btn-success mb-3">
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Saving...
            </>
          ) : (
            'Save'
          )}
        </button>
      </form>
    </div>
  );
}

export default SearchActivityForm;
